export default "__VITE_ASSET__e747fea5__"